import { useAppConfig } from '@/shared/features/app-config/context/app-config-context';
import { TFilterPreferencesConfig } from '@/shared/features/filter-preferences/context/filter-preferences-config-context.types';

export const useFilterPreferencesConfig = (): TFilterPreferencesConfig =>
  useAppConfig().filterPreferences;
